<div class="grow container">
  <lum-ui-autocomplete
    [placeholder]="'Search store'"
    [options]="omsStores"
    [debounceTime]="500"
    [loading$]="loading$"
    [displayProperty]="'storeName'"
    [value]="displayValue"
    (inputChangeEvent)="onChangeEvent($event)"
    (optionSelectedEvent)="onSelectEvent($event)"
    class="input-box"
    (scrollPaginate)="onScrollPaginate()"
  ></lum-ui-autocomplete>

  <div class="action-box align-center cursor-pointer">
    <mat-progress-spinner
      *ngIf="syncLoading$ | async"
      class="progress-spinner"
      diameter="28"
      mode="indeterminate"
    ></mat-progress-spinner>
    <a
      *ngIf="!(syncLoading$ | async)"
      href="javascript:;"
      (click)="onHardRefreshStores()"
      title="Get stores from OMS"
    >
      <lum-ui-icon
        icon="download-button"
        width="28"
        height="28"
        color="#418AA0"
      ></lum-ui-icon>
    </a>
  </div>
</div>
